export const colors = {
  // Brand
  primary: '#4527A0',
  primaryDark: '#311B92',
  primaryLight: '#7E57C2',

  // Accent — warm coral-orange
  accent: '#FF6B35',
  accentLight: '#FF8F66',
  accentDark: '#E05520',
  accentBg: 'rgba(255, 107, 53, 0.08)',

  // Status
  success: '#34C759',
  warning: '#FF9500',
  error: '#FF3B30',
  info: '#007AFF',

  // Veg / Non-veg
  veg: '#34C759',
  nonVeg: '#FF3B30',

  // Neutral
  white: '#FFFFFF',
  black: '#000000',
  grey: '#86868B',
  greyLight: '#F5F5F7',
  greyDark: '#636366',

  // Category chip states
  catNotSelectedBG: 'rgba(255, 255, 255, 0.72)',
  catNotSelectedTXT: '#1D1D1F',
  catSelectedBG: '#4527A0',
  catSelectedTXT: '#FFFFFF',

  // Cloud Canvas surfaces — glassmorphic
  background: '#EBEBEF',
  surface: 'rgba(255, 255, 255, 0.72)',
  surfaceSolid: '#FFFFFF',
  surfaceSecondary: '#F9F9FB',

  // Glassmorphic tokens
  glass: {
    background: 'rgba(255, 255, 255, 0.72)',
    backgroundHover: 'rgba(255, 255, 255, 0.85)',
    border: 'rgba(0, 0, 0, 0.06)',
    borderHover: 'rgba(0, 0, 0, 0.10)',
    blur: 'blur(20px) saturate(180%)',
  },

  text: {
    primary: '#1D1D1F',
    secondary: '#86868B',
    disabled: '#C7C7CC',
    hint: '#AEAEB2',
  },

  // Borders & dividers
  divider: 'rgba(0, 0, 0, 0.06)',
  border: 'rgba(0, 0, 0, 0.06)',
  borderLight: 'rgba(0, 0, 0, 0.03)',

  // Shadows — soft elevation
  shadow: '0 2px 12px rgba(0, 0, 0, 0.04)',
  shadowMedium: '0 4px 20px rgba(0, 0, 0, 0.06)',
  shadowDark: '0 8px 32px rgba(0, 0, 0, 0.08)',
};

export default colors;
